"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterContentBlockInputModelSubType = void 0;
exports.ChapterContentBlockInputModelSubType = {
    P: "p",
    H1: "h1",
    H2: "h2",
    H3: "h3",
};
